import './Players.css'
import { useState, useEffect } from 'react'

export default function Players() {

    const [players, setPlayers] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {
        fetchPlayersFromSheet()
    }, [])

    const fetchPlayersFromSheet = async () => {
        try {
            // Use the export URL - works perfectly with iOS Safari
            const url = 'https://docs.google.com/spreadsheets/d/16uv0QipvDPfdqxPcZ__9_EGbvmMi_TDC4A8nIxOQyHE/export?format=csv&gid=0'

            const controller = new AbortController()
            const timeoutId = setTimeout(() => controller.abort(), 10000) // 10 second timeout

            const response = await fetch(url, {
                method: 'GET',
                mode: 'cors',
                cache: 'no-cache',
                signal: controller.signal
            })

            clearTimeout(timeoutId)

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`)
            }

            const csvText = await response.text()

            const rows = csvText.split('\n').filter(row => row.trim() !== '')
            const playerData = rows.slice(1).map(row => {
                const [name, elo] = row.split(',')
                return { name: name?.trim(), elo: elo?.trim() }
            }).filter(player => player.name)

            if (playerData.length === 0) {
                throw new Error('No player data found')
            }

            setPlayers(playerData)
            setError(null)
        } catch (error) {
            console.error('Error fetching data from Google Sheets:', error)
            setError(error.message)

        } finally {
            setLoading(false)
        }
    }

    const getRankClass = (index) => {
        if (index === 0) return 'rank-1'
        if (index === 1) return 'rank-2'
        if (index === 2) return 'rank-3'
        return ''
    }

    const getMedal = (index) => {
        if (index === 0) return '🥇'
        if (index === 1) return '🥈'
        if (index === 2) return '🥉'
        return ''
    }

    const nameElement = players.map((player, index) => (
        <div key={index} className={`player-card ${getRankClass(index)}`}>
            <div className="rank-number">{index + 1}</div>
            <div className="player-info">
                <span className="medal">{getMedal(index)}</span>
                <span className="player-name">{player.name}</span>
            </div>
            <div className="player-elo">{player.elo}</div>
        </div>
    ))

    return (
        <section className="players-section">
            <h1 className='players-stars'>ELO RANKING</h1>
            <p className="ranking-description">An internal ranking system that ranks players based on their skills, participation, and contribution to the team.</p>
            <h2>REAL WOOD</h2>
            {loading ? (
                <p className="loading-text">Loading rankings...</p>
            ) : error ? (
                <p className="error-text">Unable to load rankings. Please try again later.</p>
            ) : players.length > 0 ? (
                <div className="rankings-container">
                    {nameElement}
                </div>
            ) : (
                <p className="loading-text">No rankings available</p>
            )}
        </section>
    )
}